import React, { useCallback } from "react";
import Button from "root/components/Button";
import t from "common/i18n";
import { usePurchaseInfo, useSelectedAsset } from "../../getty-selectors";
import SVG_ICONS from "~/assets/icons/icons";

export default ({ uploadAsset, purchaseAsset, inProgress, source }) => {

	const { isAlreadyPurchased, canPurchase, canUpload } = usePurchaseInfo(source);
	const { selectedFormat } = useSelectedAsset(source);

	const icon = isAlreadyPurchased && !canUpload ? SVG_ICONS.ARROW_FORWARD : ( !canUpload ? SVG_ICONS.CART : SVG_ICONS.CLOUD_PLUS);
	const buttonText =
			isAlreadyPurchased && !canUpload
			? t(`${source}.buttons.next`)
			: canUpload
			? t(`${source}.buttons.upload`)
				: t(`${source}.buttons.purchase`);

	const isDisabled = !( canPurchase || (isAlreadyPurchased && selectedFormat));
	const colorName = isAlreadyPurchased && !canUpload ? "action" : "link";

	const purchaseButtonClick = useCallback(() => {
		if ((canPurchase || (isAlreadyPurchased && selectedFormat))  && !canUpload) {
			purchaseAsset();
		}
		else if (canUpload) {
			uploadAsset();
		}
	}, [canPurchase, canUpload, purchaseAsset, uploadAsset, isAlreadyPurchased, selectedFormat]);

	return <Button text={buttonText} inProgress={inProgress} colorName={colorName} icon={icon} disabled={isDisabled} onClick={purchaseButtonClick} />;
};
